import { makeStyles } from '@material-ui/core';

const useFormFieldRendererStyles = makeStyles((theme) => {
    return ({

        muiInput:{
            '& *.Mui-error': {
                borderColor: '  #B71C1C'
            },
          },
      

        labelText: {
            "& label": {
                fontWeight: 400,
                color: '#212121',
                fontSize: '16px'
            }
        },
        milestoneLabelText: {
            "& label": {
                fontWeight: 500,
                color: '#212121',
                fontSize: '16px'
            }
        },
        greySpan: {
            "& span": {
                color: "#757575"
            }
        },
        formControl: {
            background: 'red',
            '& .MuiFormControl-root': {
                background: 'green',
            }
        },
        dataPullMainContainer: {
            position: 'relative',
            color: '#212121'
        },
        closeIcon: {
            position: 'absolute',
            top: 0,
            right: 0,
            cursor: 'pointer'
        },
        dataPullContentContainer: {
            padding: '16px 16px 0px 16px'
        },
        dataPullHeading: {
            fontSize: '20px',
            fontWeight: 500,
            paddingBottom: '10px'
        },
        dataPullContents: {
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
        },
        dataPullSubHeading: {
            fontWeight: 500
        },
        dataPullList: {
            paddingLeft: '28px'
        },
        closeButton: {
            background: '#007DB8 !important',
            borderRadius: '0.25rem',
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: '1.875rem',
            fontFamily: 'var(--font-family-bold)',
            textTransform: 'capitalize',
            color: 'var(--white) !important',
        },
        securityBadge: {
            display: 'flex',
            padding: '8px',
            borderRadius: '4px',
            fontSize: '12px',
            backgroundColor: '#F5F5F5',
            color: '#004B6C',
            height: '32px',
            alignItems: 'center'
        },
        syncAccountingTitleWrapper: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    });
});

export default useFormFieldRendererStyles;
